import React, { Dispatch, SetStateAction } from "react";
import { ImBook } from "react-icons/im";
import { FaRegKeyboard, FaDiscord } from "react-icons/fa";
import { SiSimpleanalytics } from "react-icons/si";
import { useRouter } from "next/router";
import {
  MdOutlineSpeakerNotes,
  MdInfoOutline,
  MdOutlineClose,
} from "react-icons/md";
import Feedback from "../Feedback";
import Sidebar from "../Micro/Sidebar";
import useIsTeam from "../../hooks/useIsTeam";
import useTeams from "../../hooks/useTeams";
import { RiCommandFill } from "react-icons/ri";
import { ModalContent } from "../Micro/Modal/Modal";
import { SectionItem } from "../../decleration";
import { Menu, MenuItem, MenuButton } from "@szhsin/react-menu";
import { IoServerOutline, IoClipboardOutline, IoSearch } from "react-icons/io5";
import useLogout from "../../hooks/useLogout";
import LLMIcon from "@/Icons/LLMIcon";
import config from "@/config";

const Shortcut = () => {
  const router = useRouter();
  const logout = useLogout();
  const { isTeam, team } = useIsTeam();
  const { teams } = useTeams();
  const [modal, setModal] = React.useState(false);
  const [keyboardShortcut, setKeyboardShortcut] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");

  const features = React.useMemo(
    () => [
      {
        name: "Analytics",
        icon: (
          <span>
            <SiSimpleanalytics />
          </span>
        ),
        onClick: () =>
          router.push(isTeam ? `/teams/${team}/projects` : "/projects"),
      },
      {
        name: "Buy Domain",
        icon: (
          <span>
            <IoServerOutline />
          </span>
        ),
        onClick: () => router.push(isTeam ? `/domains/new` : "/domains/new"),
      },
      {
        name: "Change Log",
        icon: (
          <span>
            <IoClipboardOutline />
          </span>
        ),
        onClick: () =>
          (window as any).Featurebase("manually_open_changelog_popup"),
      },
      {
        name: "Brimble LLM",
        icon: (
          <span>
            <LLMIcon />
          </span>
        ),
        onClick: () => window.open(config.POSTMAN_API_DOCS_URL, "_blank"),
      },
    ],
    [isTeam, router, team],
  );

  const help = React.useMemo(
    () => [
      {
        name: "Send Feedback",
        icon: (
          <span>
            <MdOutlineSpeakerNotes />
          </span>
        ),
        onClick: () =>
          window.postMessage({
            target: "FeaturebaseWidget",
            data: { action: "openFeedbackWidget" },
          }),
      },
      {
        name: "Contact Support",
        icon: (
          <span>
            <MdInfoOutline />
          </span>
        ),
        onClick: () => window.open("mailto:hello@brimble.app", "_blank"),
      },
      {
        name: "Documentation",
        icon: (
          <span>
            <ImBook />
          </span>
        ),
        onClick: () => window.open("https://docs.brimble.io", "_blank"),
      },
      {
        name: "Keyboard Shortcut",
        icon: (
          <span>
            <FaRegKeyboard />
          </span>
        ),
        onClick: () => setKeyboardShortcut(true),
      },
      {
        name: "Discord Community",
        icon: (
          <span>
            <FaDiscord />
          </span>
        ),
        onClick: () => window.open("https://discord.gg/XBCBwbXQJQ", "_blank"),
      },
      ,
    ],
    [],
  );

  const projectSection = React.useMemo(
    () => [
      {
        name: "New project",
        shortcut: "N",
        onClick: () =>
          router.push(isTeam ? `/teams/${team}/projects/new` : "/projects/new"),
      },
      {
        name: "Go to projects",
        shortcut: "G",
        shortcut2: "P",
        onClick: () =>
          router.push(isTeam ? `/teams/${team}/projects` : `/projects`),
      },
      {
        name: "Open live project",
        shortcut: (
          <span>
            <RiCommandFill />
          </span>
        ),
        shortcut2: "Enter",
        onClick: () => console.log("project"),
      },
    ],
    [searchQuery, router],
  );

  const teamSection = React.useMemo(
    () => [
      {
        name: "New team",
        shortcut: "T",
        onClick: () => router.push("/teams/new"),
      },
      {
        name: "Go to teams",
        shortcut: "G",
        shortcut2: "T",

        onClick: () =>
          teams.map((team: any) => {
            router.push(`/teams/${team.name}`);
          }),
      },
    ],
    [searchQuery, router],
  );

  const domainSection = React.useMemo(
    () => [
      {
        name: "Buy Domain",
        shortcut: "B",
        onClick: () => router.push(isTeam ? `/domains/new` : "/domains/new"),
      },
      {
        name: "New Domain",
        shortcut: "D",

        onClick: () =>
          router.push(
            isTeam ? `/teams/${team}/domains/register` : "/domains/register",
          ),
      },
      {
        name: "Go to domains",
        shortcut: "G",
        shortcut2: "D",
        onClick: () =>
          router.push(isTeam ? `/teams/${team}/domains` : "/domains"),
      },
    ],
    [searchQuery, router],
  );

  const general = React.useMemo(
    () => [
      {
        name: "Open command menu",
        shortcut: (
          <span>
            <RiCommandFill />
          </span>
        ),
        shortcut2: "K",
        onClick: () => console.log("Open Scoutbar"),
      },

      {
        name: "Logout",
        shortcut: "L",
        onClick: () => logout(),
      },
    ],
    [searchQuery],
  );

  return (
    <div className="relative z-[9999999999]">
      <Menu
        menuButton={
          <MenuButton className="h-7 w-7 overflow-y-auto rounded-full border border-theme-color-lighter border-opacity-30 text-sm">
            ?
          </MenuButton>
        }
      >
        <div className="relative top-6 w-64 divide-y bg-white pb-2 shadow-md dark:divide-gray-dark dark:divide-opacity-20 dark:bg-theme-color-light">
          <div className="p-2">
            <label className="p-1 text-sm font-medium text-[#616161]">
              What&apos;s New?
            </label>
            {features.map((item, index) => (
              <div className={`${index === 0 ? "mt-2" : ""}`} key={index}>
                <MenuItem>
                  {() => (
                    <div
                      onClick={item.onClick}
                      className={`btn-transparent btn flex w-full flex-row flex-nowrap justify-start gap-x-2 whitespace-nowrap !rounded-md !text-left text-sm font-medium text-[#616161] hover:!bg-primary hover:text-white hover:dark:!bg-theme-color`}
                    >
                      {item.icon}
                      <span className="pl-1 text-sm font-medium">
                        {item.name}
                      </span>
                    </div>
                  )}
                </MenuItem>
              </div>
            ))}
          </div>
          <div className="p-2">
            <label className="p-1 text-sm font-medium text-[#616161]">
              Help
            </label>
            {help.map((item, index) => (
              <div className={`${index === 0 ? "mt-2" : ""}`} key={index}>
                <MenuItem>
                  {() => (
                    <div
                      onClick={item?.onClick}
                      className={`btn-transparent btn flex w-full flex-row flex-nowrap justify-start gap-x-2 whitespace-nowrap !rounded-md !text-left text-sm font-medium text-[#616161] hover:!bg-primary hover:text-white hover:dark:!bg-theme-color`}
                    >
                      {item?.icon}
                      <span className="text-sm font-medium">{item?.name}</span>
                    </div>
                  )}
                </MenuItem>
              </div>
            ))}
          </div>
        </div>
      </Menu>
      {keyboardShortcut && (
        <ShortcutDrawer
          projectSection={projectSection}
          domainSection={domainSection}
          teamSection={teamSection}
          general={general}
          onClose={() => setKeyboardShortcut(false)}
          open={keyboardShortcut}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery as Dispatch<SetStateAction<string>>} // Type assertion
        />
      )}
      <Feedback modal={modal} setModal={setModal} />
    </div>
  );
};
export default Shortcut;

const ShortcutDrawer = ({
  onClose,
  open,
  projectSection,
  teamSection,
  domainSection,
  general,
  searchQuery,
  setSearchQuery,
}: {
  onClose(): void;
  open: boolean;
  projectSection: SectionItem[];
  teamSection: SectionItem[];
  domainSection: SectionItem[];
  general: SectionItem[];
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
}) => {
  const filterSections = (sections: SectionItem[]) => {
    if (!searchQuery) {
      return sections;
    }
    return sections.filter((item: SectionItem) => {
      return (
        item.shortcut == searchQuery.toUpperCase() ||
        item.shortcut2 == searchQuery.toUpperCase()
      );
    });
  };
  const filteredProjectSection = filterSections(projectSection);
  const filteredTeamSection = filterSections(teamSection);
  const filteredDomainSection = filterSections(domainSection);
  const filteredGeneralSection = filterSections(general);
  return (
    <Sidebar
      open={open}
      onClose={onClose}
      className="z-[999999] h-full overflow-y-auto"
    >
      <ModalContent className="fixed right-0 top-16 w-96 rounded-lg bg-white shadow-md dark:bg-theme-color-light">
        <div>
          <div className="px-3">
            <div className="flex items-center justify-between py-2 text-black">
              <span className="text-base font-bold dark:text-white">
                Keyboard Shortcut
              </span>
              <span
                onClick={onClose}
                className="cursor-pointer text-xl dark:text-white"
              >
                <MdOutlineClose />
              </span>
            </div>
            <div className="relative w-full">
              <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                <IoSearch className="text-black dark:text-white" />
              </div>
              <input
                id="searchInput"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search Shortcuts"
                className="my-3 h-12 w-full rounded-md border border-primary/50 pl-10 pr-5 placeholder:text-xs placeholder:text-black dark:bg-theme-color dark:text-white dark:placeholder:text-white"
              />
            </div>
          </div>

          <div>
            <label className="flex w-full border-b border-light p-3 text-sm font-semibold text-black dark:border-opacity-10 dark:text-[#616161]">
              Projects
            </label>
            <Section section={filteredProjectSection} />
          </div>
          <div>
            <label className="flex w-full border-b border-light p-3 text-sm font-semibold text-black dark:border-opacity-10 dark:text-[#616161]">
              Teams
            </label>
            <Section section={filteredTeamSection} />
          </div>

          <div className="">
            <label className="flex w-full border-b border-light p-3 text-sm font-semibold text-black dark:border-opacity-10 dark:text-[#616161]">
              Domains
            </label>{" "}
            <Section section={filteredDomainSection} />
          </div>

          <div className="mb-2">
            <label className="flex w-full border-b border-light p-3 text-sm font-semibold text-black dark:border-opacity-10 dark:text-[#616161]">
              General
            </label>{" "}
            <Section section={filteredGeneralSection} />
          </div>
        </div>
      </ModalContent>
    </Sidebar>
  );
};

const Section = ({ section }: { section: SectionItem[] }) => {
  return (
    <>
      {section.map((item: SectionItem, index: number) => (
        <div className={`${index === 0 ? "mt-2" : ""} px-2`} key={index}>
          <div
            onClick={item.onClick}
            className={`btn-transparent btn flex w-full flex-row flex-nowrap justify-between whitespace-nowrap !rounded-md !text-left text-sm font-medium text-[#616161] hover:!bg-primary hover:text-white hover:dark:!bg-theme-color`}
          >
            <span className="text-sm font-medium">{item.name}</span>
            <div className="flex items-center">
              <span className="flex w-fit items-center justify-center rounded-[4px] bg-white px-2 py-1 text-sm text-primary shadow-md dark:bg-theme-color">
                {item.shortcut}
              </span>
              {item.shortcut2 && (
                <>
                  <span className="mx-2 text-sm lowercase">then</span>
                  <span className="flex w-fit items-center justify-center rounded-[4px] bg-white px-2 py-1 text-sm text-primary shadow-md dark:bg-theme-color">
                    {item.shortcut2}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};
